module.exports = __webpack_public_path__ + "static/media/the-catfather-part-II.24d63db1.gif";